import { React, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CourseGrid from './course-grid';
import { handleCursos } from '../../../api/curso';
import { useNavigate } from "react-router-dom";
import { retrieveToken } from '../../../hooks/use-token';

const AllCourses = ({list}) => {

  const [allCourses, setAllCourses] = useState([]);
  const [isLogged, setIsLogged] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {

      if (allCourses.length === 0) {
          
          const tokenApi = retrieveToken();

          if (!tokenApi) {
            setIsLogged(false);
            // navigate("/entrar");
          } else {
            setIsLogged(true);
          }

          handleCursos(tokenApi).then(function(result) {
            setAllCourses(result);
          }).catch(function(error) {
            if (error.message === 'Unauthorized') {
                // Tratar o status 401 aqui, por exemplo, redirecionar para a página de login
                console.log('Usuário não autorizado. Redirecionando para a página de login...');
            } else {
                // Tratar outros erros
                console.error('Erro ao obter cursos:', error);
            }
        });

      }

  }, [navigate]);

  const short_filter = ['Default', 'Featured', 'Free', 'Paid', 'Trending'];

  return (
    <>
      <section className="course__area pt-120 pb-120">
        <div className="container">
        {isLogged && (<p>Você está logado, <Link to="/meus-cursos" style={{color: '#956AF5'}}>clique aqui</Link> para ver os seus cursos.</p>)}
          
          <div className="row mt-50">
            <div className="col-xxl-12">
              <div className="course__tab-conent">
                <div className="tab-content" id="courseTabContent">
                  <div className={`tab-pane fade ${!list && 'show active'}`} id="grid" role="tabpanel" aria-labelledby="grid-tab">
                    <div className="row">
                      <CourseGrid itemsPerPage={50} items={allCourses} />
                    </div>
                  </div>

                  {/* <div className={`tab-pane fade ${list && 'show active'}`} id="list" role="tabpanel" aria-labelledby="list-tab">
                    <div className="row">
                      <CourseList itemsPerPage={50} items={allCourses} />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );

};

export default AllCourses;